import React from 'react';
import { Star } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { testimonials } from '../mock';
import { useTranslation, Trans } from 'react-i18next';

export const Reviews = () => {
  const { t } = useTranslation();

  return (
    <section id="reviews" className="py-24 bg-neutral-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-extrabold text-white mb-4">
           <Trans i18nKey="reviews_title">
              What Our <span className="text-lime-400">Customers Say</span>
            </Trans>
          </h2>
          <p className="text-xl text-neutral-300 max-w-2xl mx-auto">
            {t('reviews_subtitle')}
          </p>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((review) => (
            <Card
              key={review.id}
              className="bg-neutral-900 border-neutral-800 hover:border-lime-500/30 transition-all duration-300 hover:shadow-xl hover:shadow-lime-500/10"
            >
              <CardContent className="p-6 space-y-4">
                {/* Stars */}
                <div className="flex space-x-1">
                  {[...Array(review.rating)].map((_, i) => (
                    <Star key={i} className="h-5 w-5 text-lime-400 fill-current" />
                  ))}
                </div>

                {/* Review Text */}
                <p className="text-neutral-200 leading-relaxed">
                  "{t(review.text)}"
                </p>

                {/* Reviewer Info */}
                <div className="pt-4 border-t border-neutral-800">
                  <p className="font-semibold text-white">{review.name}</p>
                  <p className="text-sm text-neutral-400">{t(review.date)}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Google Reviews CTA */}
        <div className="text-center mt-12">
          <p className="text-neutral-300 text-lg">
            {t('reviews_more')}{' '}
            <a
              href="#"
              className="text-lime-400 hover:text-lime-300 font-semibold underline"
            >
              {t('google_link')}
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};
